import schemas from 'components/forms/fields/definedSchemas';
// import Joi from 'joi';

const fields = {
    _ssl_attached: {
        ...schemas.boolOptional,
        label: 'Is your tankerman letter attached to a Sea Service Letter?',
        section: 'Signature',
    },
    _official_letterhead: {
        ...schemas.boolRequiredTrue,
        label: 'Is your Tankermen letter on your company’s/ship’s official letterhead?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be on official letterhead.',
        }),
    },
    _document_signed: {
        ...schemas.boolRequiredTrue,
        label: 'Is this Tankerman Letter signed by the Master of the Vessel, the Chief Engineer, a senior company official or the owner of the vessel? ',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be signed.',
        }),
    },
    date_signed: {
        ...schemas.dateRequiredMaxToday,
        label: 'What date was the document signed by the person attesting to this experience?',
        section: 'Signature',
        name: 'date_signed',
    },
    loadings: {
        ...schemas.tankermanArray,
        label: 'Loadings',
        section: 'Loadings',
        name: 'loadings',
    },
    discharges: {
        ...schemas.tankermanArray,
        label: 'Discharges',
        section: 'Discharges',
        name: 'discharges',
    },
    commencement_loadings: {
        ...schemas.tankermanArray,
        label: 'Commencement of Loadings',
        section: 'CommencementLoadings',
        name: 'commencement_loadings',
    },
    completion_loadings: {
        ...schemas.tankermanArray,
        label: 'Completion of Loadings',
        section: 'CompletionLoadings',
        name: 'completion_loadings',
    },
    commencement_discharges: {
        ...schemas.tankermanArray,
        label: 'Commencement of Discharges',
        section: 'CommencementDischarges',
        name: 'commencement_discharges',
    },
    completion_discharges: {
        ...schemas.tankermanArray,
        label: 'Completion of Discharges',
        section: 'CompletionDischarges',
        name: 'completion_discharges',
    },
    _ssl_id: {
        ...schemas.integerOptional,
        label: 'Associated SSL ID',
        section: 'AssociateSsl',
        name: '_ssl_id',
        initialValue: null,
    },

    _jsonMap: {
        date: 'Date',
        transfer_type: 'Type',
        _signed: 'Signed',
    },
};

export default fields;
